import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import AOS from "aos";
import "aos/dist/aos.css";

import {
  FaEye,
  FaBullseye,
  FaLightbulb,
  FaShieldAlt,
  FaAward,
  FaHandsHelping,
} from "react-icons/fa";

import banner5 from "../assets/banner1.jpg";

export default function HomeBanner3() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
    AOS.init({ duration: 900, easing: "ease-out-cubic", once: false });
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  const strategyCards = [
    {
      title: "Vision",
      icon: <FaEye size={34} />,
      content:
        "To become a leading African conglomerate powered by technology, innovation, and solutions that improve life and business.",
    },
    {
      title: "Mission",
      icon: <FaBullseye size={34} />,
      content:
        "To build and operate companies that create value, solve real problems, and empower communities through modern, tech-enabled approaches.",
    },
    {
      title: "Core Values",
      icon: <FaAward size={34} />,
      values: [
        {
          icon: <FaLightbulb />,
          label: "Innovation",
          text: "Building for today and the future.",
        },
        {
          icon: <FaShieldAlt />,
          label: "Integrity",
          text: "Doing business the right way.",
        },
        {
          icon: <FaAward />,
          label: "Excellence",
          text: "Delivering high-quality services.",
        },
        {
          icon: <FaHandsHelping />,
          label: "Impact",
          text: "Creating solutions that improve lives.",
        },
      ],
    },
  ];

  return (
    <section
      className="MainBodySection"
      style={{
        padding: "90px 0",
        backgroundImage: `url(${banner5})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
      }}
    >
      {/* Overlay */}
      <div
        style={{
          background: "rgba(0,0,0,0.6)",
          position: "absolute",
          inset: 0,
        }}
      />

      <div className="container position-relative">
        {/* Header */}
        <div className="row justify-content-center mb-5 text-center">
          <div className="col-lg-9">
            <h2
              className="main-section-title font-bold mb-3"
              data-aos="fade-down"
            >
              Vision, Mission & Core Values
            </h2>
            <p
              className="text-light"
              style={{
                maxWidth: "760px",
                margin: "0 auto",
                lineHeight: 1.7,
                opacity: 0.9,
              }}
            >
              The principles that guide how Ndomano Group of Companies builds,
              operates, and scales its businesses.
            </p>
          </div>
        </div>

        {/* Cards */}
        <div className="row g-4 justify-content-center">
          {strategyCards.map((card, idx) => (
            <div key={idx} className="col-md-6 col-lg-4" data-aos="fade-up">
              <div
                className="h-100 rounded-4 p-4 text-center"
                style={{
                  background: "rgba(255,255,255,0.14)",
                  backdropFilter: "blur(14px)",
                  WebkitBackdropFilter: "blur(14px)",
                  border: "1px solid rgba(255,255,255,0.2)",
                  boxShadow: "0 12px 32px rgba(0,0,0,0.35)",
                  color: "#fff",
                  transition: "all 0.35s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-6px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                {/* Icon */}
                <div
                  className="mb-3 text-primary"
                  style={{ fontSize: "1.8rem" }}
                >
                  {card.icon}
                </div>

                <h5 className="fw-bold mb-3">{card.title}</h5>

                {/* Content */}
                {card.content && (
                  <p
                    style={{
                      lineHeight: 1.6,
                      fontSize: "0.95rem",
                      opacity: 0.95,
                    }}
                  >
                    {card.content}
                  </p>
                )}

                {/* Core Values List */}
                {card.values && (
                  <div className="text-start mt-3">
                    {card.values.map((val, i) => (
                      <div
                        key={i}
                        className="d-flex align-items-start mb-3"
                        style={{ gap: "12px" }}
                      >
                        <div
                          className="text-primary"
                          style={{ fontSize: "1.1rem", marginTop: "2px" }}
                        >
                          {val.icon}
                        </div>
                        <div>
                          <strong>{val.label}</strong>
                          <div
                            style={{
                              fontSize: "0.85rem",
                              opacity: 0.9,
                              lineHeight: 1.4,
                            }}
                          >
                            {val.text}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
